export const ARTICLE_ID_SELECTOR = 'coverLetterContent'
